module.exports = __webpack_public_path__ + "img/rm-lt-03.100822f5.webp";